module.exports = __webpack_public_path__ + "static/media/wallet_login_cut.c74185e0.jpg";